export const buildSubHeading = (products) => {
  if (!products?.length) return '';
  return products.map((product) => `${product.quantity} x ${product.name}`).join(' + ');
};

// Cart/order lines carry no explicit bundle flag (no item_type/product_type), and BE has already
// renamed the product title format once (from "Bundle <Category> <n>" to "<Category> Credits
// Bundles <n>" / "Refresh Credits <n>") — match loosely on both formats instead of a strict prefix
// so the next BE wording tweak doesn't silently break detection again.
const BUNDLE_CATEGORY_KEYWORDS = ['super hot', 'hot', 'refresh'];

export const isBundleProductTitle = (title) => {
  if (!title) return false;
  const lower = title.toLowerCase();
  if (lower.startsWith('bundle ')) return true;
  return lower.includes('credit') && BUNDLE_CATEGORY_KEYWORDS.some((keyword) => lower.includes(keyword));
};

const decorateBundle = (bundle) => {
  const pricePerCredit = bundle?.total_credits ? Math.round(bundle.price / bundle.total_credits) : bundle.price;
  const originalTotal =
    bundle?.discount_percent > 0 ? Math.round(bundle.price / (1 - bundle.discount_percent / 100)) : null;

  return {
    ...bundle,
    pricePerCredit,
    originalTotal,
    subHeading: buildSubHeading(bundle?.products),
  };
};

const bundlesApis = {
  getBundles: {
    query: () => {
      return { url: '/api/surge/bundles' };
    },
    transformer: (response) => {
      const data = response?.data ?? response;
      return {
        available: !!data?.available,
        zone: data?.zone,
        province: data?.province,
        currency: data?.currency,
        categories:
          data?.categories?.map((category) => ({
            ...category,
            bundles: category?.bundles?.map(decorateBundle) ?? [],
          })) ?? [],
      };
    },
  },
};

export default bundlesApis;
